<template>
    <div id="commande-list">

        <b-modal ref="my-modal" scrollable title="Détail commande" ok-only ok-title="Annuler" size="xl"
            cancel-variant="outline-secondary">

            <b-table :bordered="true" :small="true" :hover="true" :no-border-collapse="true" :items="commandesSelected"
                :fields="fields" />

        </b-modal>

        <b-overlay :show="show" spinner-variant="primary">
            <b-card>

                <ag-grid :withFilters="true" :filterComponent="AgGridDateFilter" :agGrid="agGrid"
                    pageTitle="Liste des commandes" @refresh="loadData" @filterClicked="filterClicked" />

            </b-card>
        </b-overlay>


    </div>
</template>

<script>
import AgGrid from "@/views/components/ag-grid/AgGrid.vue"
import ButtonCellRenderer from "@/views/components/ag-grid/ButtonCellRenderer.vue"
import BadgeCellRenderer from "@/views/components/ag-grid/BadgeCellRenderer.vue"
import AgGridDateFilter from '@/views/components/ag-grid/AgGridDateFilterCurrDate.vue';
import { formatPrice } from "@/utils/formatting";

export default {
    components: {
        // VueAutosuggest,
        AgGrid,
    },
    data() {
        return {
            AgGridDateFilter: AgGridDateFilter,
            startDate: new Date().toISOString().split('T')[0],
            endDate: new Date().toISOString().split('T')[0],
            agGrid: {
                columnDefs: [
                    {
                        headerName: "Client",
                        field: "Bill_to_Name",
                        // width: 180
                    },
                    {
                        headerName: "N° BL",
                        field: "Last_Shipping_No",
                        // width: 180
                    },
                    {
                        headerName: "Date Commande",
                        field: "Posting_Date",
                        valueGetter: function (tr) {
                            return tr.data.Posting_Date.substring(0, 10);
                        },
                        //cellClass: 'right-customeCellRender',
                        //headerClass: 'right-customeHeaderRender',
                        // width: 200
                    },
                    // {
                    //     headerName: "N° Commande",
                    //     field: "No",
                    //     // width: 180,
                    // },
                    {
                        headerName: "Commandé Par",
                        field: "User_ID",
                        // width: 200
                    },
                    {
                        headerName: "Type",
                        field: "Gen_Prod_Posting_Group",
                        cellRendererFramework: 'badgeCellRenderer',
                        cellRendererParams: { componentName: "Orders", columnName: "Gen_Prod_Posting_Group" },
                        // width: 100
                    },
                    {
                        headerName: "Montant",
                        field: "Amount",
                        valueGetter: function (tr) {
                            return formatPrice(tr.data.Amount);
                        },
                        //cellClass: 'right-customeCellRender',
                        //headerClass: 'right-customeHeaderRender',
                        // width: 130
                    },
                    {
                        headerName: "Statut",
                        field: "Order_Status",
                        cellRendererFramework: 'badgeCellRenderer',
                        cellRendererParams: { componentName: "Orders", columnName: "Order_Status" },
                        // width: 200
                    },
                    {
                        sortable: false,
                        resizable: false,
                        filter: false,
                        cellClass: 'centered-customeCellRender',
                        cellRendererFramework: 'buttonCellRenderer',
                        cellRendererParams: { onButtonClick: this.showDetails, icon: "read_more" },
                        headerName: '',
                        width: 100
                    },

                ],
                rows: []
            },
            fields: [{
                label: 'Code Article',
                key: 'No',
                sortable: true
            },
            {
                label: 'Désignation article',
                key: 'Description',
                sortable: true
            },
            {
                label: 'Prix',
                key: 'Unit_Price',
                sortable: true
            }, {
                label: 'Quantité',
                key: 'Quantity',
                sortable: true
            }
            ],
            commandesSelected: [],
            show: true,
        }
    },
    created() {
        this.$options.components.buttonCellRenderer = ButtonCellRenderer;
        this.$options.components.badgeCellRenderer = BadgeCellRenderer;
        this.loadData();
    },
    methods: {
        filterClicked(obj) {
            this.startDate = obj.sDate;
            this.endDate = obj.eDate;
            this.loadData();
        },
        async showDetails(event) {
            this.show = true;
            let response = await this.$http.get("order_line/findWhere", {
                params: {
                    Document_No: "'" + event.No + "'"
                }
            }).catch(() => this.show = false);
            this.commandesSelected = response.data;
            this.show = false;
            this.$refs['my-modal'].show();
        },
        async loadData() {
            this.show = true;
            let response = await this.$http.post("order_header/findWhere", this.generateDateFilters());
            
            this.agGrid.rows = [...response.data].reverse();
            this.agGrid.rows = this.agGrid.rows.filter(x => x.No.substring(0, 2) != 'RV')
            this.show = false;
        },
        generateDateFilters() {
            const filters = [
                {
                    "field": "Posting_Date",
                    "value": "",
                    "operator": "gt"
                },
                {
                    "field": "Posting_Date",
                    "value": "",
                    "operator": "lt"
                }
            ];
            // Convert start date string to Date and adjust by -1 day
            const startDateObj = new Date(this.startDate);
            startDateObj.setDate(startDateObj.getDate() - 1);
            // Convert end date string to Date and adjust by +1 day
            const endDateObj = new Date(this.endDate);
            endDateObj.setDate(endDateObj.getDate() + 1);
            // Format adjusted dates as strings in yyyy-MM-dd format
            const formattedStartDate = startDateObj.toISOString().split('T')[0];
            const formattedEndDate = endDateObj.toISOString().split('T')[0];
            // Set adjusted date values in the filter objects
            filters[0].value = formattedStartDate;
            filters[1].value = formattedEndDate;
            return filters;
        },
    }
}
</script>

<style lang="scss">
// @import '@core/scss/vue/libs/vue-autosuggest.scss';</style>